import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';

const {
  addRequestError,
  addDisciplines,
  addSearchDisciplines,
  addNewDisciplines,
  startRequest,
  endRequest
} = actions;

const {
  API_DISCIPLINES,
  LOAD_DISCIPLINES_SAGA,
  LOAD_NEW_DISCIPLINES_SAGA
} = constants;

const apiLoadAdminDisciplines = (page, per_page = 10, query) => (
  axios.get(API_DISCIPLINES, {
    params: {
      page,
      per_page,
      ...query
    }
  })
);

function* loadDisciplines({ page = 1, query = {}, per_page = 999 }) {
  try {
    yield put(startRequest('loading_disciplines'));

    const response = yield call(apiLoadAdminDisciplines, page, per_page, query);
    const disciplines = response.data.disciplines;
    const count = response.data.count;
    const totalPages = response.data.total_pages;

    if(query.discipline_type || query.discipline_type === 0) yield put(addDisciplines(disciplines, count, page, totalPages, query));
    else yield put(addSearchDisciplines(disciplines, count, page, totalPages, query));
    yield put(endRequest('loading_disciplines'));

  } catch (e) {
    yield put(addRequestError(e.response))
    yield put(endRequest('loading_disciplines'));
  }
}

function* loadNewDisciplines({ page = 1, query = {}, per_page= 100 }) {
  try {
    yield put(startRequest('loading_disciplines'));

    const response = yield call(apiLoadAdminDisciplines, page, per_page, query);
    const disciplines = response.data.disciplines;
    const count = response.data.count;
    const totalPages = response.data.total_pages;

    yield put(addNewDisciplines(disciplines, count, page, totalPages, query));
    yield put(endRequest('loading_disciplines'));

  } catch (e) {
    yield put(addRequestError(e.response))
    yield put(endRequest('loading_disciplines'));
  }
}


function* __loadDisciplinesSaga() {
  yield takeEvery(LOAD_DISCIPLINES_SAGA, loadDisciplines)
}

function* __loadNewDisciplinesSaga() {
  yield takeEvery(LOAD_NEW_DISCIPLINES_SAGA, loadNewDisciplines)
}



export {
  __loadDisciplinesSaga,
  __loadNewDisciplinesSaga
};



// WEBPACK FOOTER //
// ./src/sagas/diciplines.js